import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-nominate-directorate',
  standalone: false,
  templateUrl: './nominate-directorate.component.html',
  styleUrl: './nominate-directorate.component.scss',
})
export class NominateDirectorateComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Input() base_url = environment.APIUrl;
  @Output() stepCompleted = new EventEmitter<void>();
  commentForm: FormGroup;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  uploadedFiles: File[] = [];
  @Input() getPraposalurl: string;
  @Input() schemeType: any;
  payload: {
    proposal_id: any;
    // proposal_step:proposalStep,
    proposal_name: any;
  };
  qaAgencyData: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  private subscriptions = new Subscription();
  userID: any;

  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    this.commentForm = this.fb.group({
      comment: [''],
      meeting_date: ['', Validators.required],
      pbg_date: ['', Validators.required],
      meeting_time: ['', Validators.required],
      meeting_venue: ['', Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName,
      };
    });
    this.getData();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  patchFormValues(data: any) {
    if (!data) return;
    //console.log(data);
    this.commentForm.patchValue({
      comment: data[0].justification,
      meeting_date: data[0].meeting_date,
      pbg_date: data[0].pbg_date,
      meeting_time: data[0].meeting_time,
      meeting_venue: data[0].meeting_venue,
    });
  }


  getData() {
    const sub = this.api
      .getAPI(
        this.getUrl +
          this.id +
          '&proposal_step__proposal=' +
          this.payload.proposal_id
      )
      .subscribe((res: any) => {
        this.qaAgencyData = res;
        this.patchFormValues(res);
        // this.commentForm.disable()
      });
    this.subscriptions.add(sub);
  }

  onSubmit() {
    //console.log(this.commentForm.value);
    const formData = new FormData();
    formData.append('justification', this.commentForm.get('comment')?.value);
    formData.append(
      'meeting_date',
      this.commentForm.get('meeting_date')?.value
    );
    formData.append('pbg_date', this.commentForm.get('pbg_date')?.value);
    formData.append('proposal_step', this.id);
    formData.append('meeting_time', this.commentForm.get('meeting_time')?.value);
    formData.append(
      'meeting_venue',
      this.commentForm.get('meeting_venue')?.value
    );
    // this.uploadedFiles.forEach(data => {
    //   formData.append('uploaded_file', data);
    // })
    if (this.qaAgencyData[0]?.id) {
      const sub = this.api
        .putAPI(`${this.postUrl}${this.qaAgencyData[0]?.id}/`, formData)
        .subscribe((res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Comment updated',
          });
          this.getData();
          // this.fileUpload.clear();
          // this.stepCompleted.emit();
        });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api
        .postAPI(`${this.postUrl}`, formData)
        .subscribe((res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Comment submitted',
          });
          this.getData();
          // this.fileUpload.clear();
          // this.stepCompleted.emit();
        });
      this.subscriptions.add(sub);
    }
  }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: 'Proposal Name', value: this.payload.proposal_name },
        { key: 'Comments', value: this.commentForm.get('comment')?.value },
        { key: 'Meeting Venue', value: this.commentForm.get('meeting_venue')?.value },
        { key: 'Meeting Date', value: this.commentForm.get('meeting_date')?.value },
        { key: 'Meeting Time', value: this.commentForm.get('meeting_time')?.value },
      ],
    };
    this.generatePDFEmitter.emit(payload);
  }
}
